<script setup>
import {defineProps, defineEmits, ref, computed, watch} from "vue";
import LayoutItem from "@/views/projects/pdf/contents/LayoutItem.vue"

const props = defineProps({
  initialLayout: Object,
  sourceType: String,
  selectedBlocks: Array,
  savedData: Object,
  findElements: Function,
  clearSelectedBlocks: Function
})

const emit = defineEmits(['save-layouts'])

const activeLayout = ref(0)
const layouts = ref([])

const findElements = (coords) => {
  return props.findElements?.(coords) || []
}

function createLayout(layoutData, preparedData) {
  if (!layoutData) return null
  const defaultPreparedData = {
    droppedItems: [],
    comments: []
  }
  return {
    ...JSON.parse(JSON.stringify(layoutData)),
    ...JSON.parse(JSON.stringify(preparedData?preparedData:defaultPreparedData)),
  }
}


function saveLayout() {
  let data = []
  layouts.value.forEach(layout=>{
    data.push({
      comments: layout.comments,
      data: layout.droppedItems,
    })
  })
  emit("save-layouts", data)
}

watch(() => props.initialLayout, (newVal) => {
  if (newVal) {
    if (props.savedData && props.savedData.json?.length){
      props.savedData.json.forEach(data=> {
        const layout = createLayout(newVal, {comments: data.comments, droppedItems: data.data})
        layouts.value.push(layout)
      });
    }
    else {
      const layout = createLayout(newVal)
      if (layout) {
        layouts.value = [layout]
      }
    }
  }
}, {immediate: true})


const currentLayout = computed(() => layouts.value[activeLayout.value])


const addLayout = () => {
  const layout = createLayout(props.initialLayout)
  if (layout) layouts.value.push(layout)
  activeLayout.value = layouts.value.length - 1
}
</script>

<template>
  <div class="layout-wrapper">
    <div class="layout-controls mb-3">
      <button class="btn btn-sm btn-outline-primary me-2" @click="addLayout">Добавить слайд</button>
      <div class="btn-group">
        <button
            v-for="(_, index) in layouts"
            :key="index"
            class="btn btn-sm"
            :class="{'btn-primary': activeLayout === index, 'btn-outline-primary': activeLayout !== index}"
            @click="activeLayout = index"
        >
          Слайд {{ index + 1 }}
        </button>
      </div>
    </div>

    <LayoutItem
    :current-layout="currentLayout"
    :selected-blocks="selectedBlocks"
    :source-type="sourceType"
    :find-elements="findElements"
    :clear-selected-blocks="clearSelectedBlocks"
    ></LayoutItem>
    <button class="btn btn-sm btn-outline-dark mt-2"
            @click="saveLayout">Сохранить все
    </button>
  </div>
</template>


<style scoped lang="scss">
.layout-wrapper {
  .layout-controls {
    display: flex;
    align-items: center;
    gap: 10px;
  }

}
</style>